import "./styles.css";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";
import Main from './pages/Main';
import Room from './pages/Room';
import Overlay from './pages/Overlay';
import Error from './pages/Error';


let router = createBrowserRouter([
  {
    path: "/",
    Component: Main,
    errorElement: <Error />,
  },
  {
    path: ":roomId",
    Component: Room,
    errorElement: <Error />,
  },
  {
  	path: "overlay/:roomId/:key",
  	Component: Overlay,
  	errorElement: <Error />,
  }
]);


createRoot(document.getElementById("app")!).render(<RouterProvider router={router} />);
